///<reference path="../../../../components/models/meevo.dtos.d.ts"/>
module Meevo.Plugins.AppointmentBook {
    "use strict";

    import DayOfWeek = Meevo.Model.DayOfWeek;
    import DataDetail = Meevo.Model.DataDetail;
    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;
    import DateTimeUnitEnum = Meevo.Model.DateTimeUnitEnum;
    import SequencePositionEnum = Meevo.Model.SequencePositionEnum; //THESE ARE AUTOGENERATED FROM SERVICESTACK
    export interface BlockSchedule {
        id?: string;
        blockType?: BlockTypeListItem;
        blockTypeId?: string;
        employeeIds?: string[];
        entityVersion?: number;
        objectState?: ObjectStateEnum;
        reason?: string;
        startDate?: string;
        startTime?: string;
        endDate?: string;
        endTime?: string;
        dayOfMonth?: number;
        daysOfWeek?: DayOfWeek[];
        frequency?: number;
        frequencyUnit?: DateTimeUnitEnum;
        occurrenceInInterval?: SequencePositionEnum;
        totalOccurrences?: number;
    }

    export interface Block {
        id?: string;
        blockType?: BlockTypeListItem;
        blockTypeId?: string;
        blockScheduleId?: string;
        employeeId?: string;
        entityVersion?: number;
        reason?: string;
        startDateTime?: Date;
        endDateTime?: Date;
        resource: any;
        resourceId?: string;
        asLocationId?: number;
        isShared?: boolean;
        locationId?: number;
        isBlockInPast?: boolean;
        displayReasonOnBook: boolean;
    }

    export interface BlockTypeListItem {
        id?: string;
        backgroundColor?: string;
        foregroundColor?: string;
        displayName?: string;
        entityVersion?: number;
        externalId?: string;
        includeInPercentBooked?: boolean;
        includeInProductivity?: boolean;
        objectState?: ObjectStateEnum;

        backgroundColorRgba: number[];
        foregroundColorRgba: number[];
    }


    //THESE ARE USED IN CLIENT SIDE CODE
    export interface BlockSchedule {
        employees: DataDetail[];
    }

    export interface Block {
        employee: any;
        employeeDisplayName; //TODO: needs to be added on the server
        originalEmployeeGlobalId;
        startDate;
        originalStartDate;
        startTimeSegmented;
        endTimeSegmented;
        suppressWarnings: boolean;
        originalResourceId;
        isInPast: boolean;
    }



    export class BlockEditorService {
        block: Block;
        blockId: Guid;
        resources: any;
        canEditPermission = false;
        canAddPermission = false;
        securityKeys = Meevo.Components.Common.SecurityKeys;
        private potentialDurationMinutes: number[];
        duration: number;

        constructor(private restServer: any, private rootScope: any, private modal: any,
            private globals: any, private securityChecker: any, private dataService: Meevo.Components.BaseClasses.IDataService,
            protected durationIncrements) {
            rootScope.$on("newBlock", (event, args) => {
                this.loadDurationIncrements();
                this.createNewBlock(moment(args.date, "M-D-YYYY").toDate(), moment(args.startTime, "h:m"), args.appointmentBookIncrement);
                this.duration = args.appointmentBookIncrement;
                this.block.employee = args.employee;
                this.block.resource = args.resource;
                this.resources = undefined;

                $('#blockEditorFormInner').show();
            });

            var blockId;
            rootScope.$on("editBlock", (event, args) => {
                blockId = args.blockId;
                this.loadDurationIncrements();
                restServer.getAppointBlock(args.blockId, (response: Block) => {

                    if (response.employee) {
                        response.employee.displayName = response.employee.lastName + ", " + response.employee.firstName;
                        response.originalEmployeeGlobalId = response.employeeId;
                    }
                    response.originalResourceId = response.resource ? response.resource.id : undefined;

                    response.startDate = moment(response.startDateTime).toDate();
                    response.originalStartDate = response.startDateTime;

                    var startTime = moment(response.startDateTime);
                    response.startTimeSegmented = {
                        value: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), Number(startTime.format("HH")), Number(startTime.format("mm")))
                    };

                    var endTime = moment(response.endDateTime);
                    response.endTimeSegmented = {
                        value: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), Number(endTime.format("HH")), Number(endTime.format("mm")))
                    };

                    this.duration = endTime.subtract(moment.duration(startTime)).totalMinutes();
                    this.block = response;
                    this.block.isInPast = response.isBlockInPast;
                    this.resources = undefined;

                    $('#blockEditorFormInner').show();
                });
            });

            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys
                .APPOINTMENTS_APPOINTMENTBOOK_ACTION_EDITBLOCK)
                .then(result => {
                    this.canEditPermission = (result == Model.SecurityAccessEnum.Grant);
                });
            this.securityChecker.checkSecurityKey(Meevo.Components.Common.SecurityKeys
                .APPOINTMENTS_APPOINTMENTBOOK_ACTION_ADDBLOCK)
                .then(result => {
                    this.canAddPermission = (result == Model.SecurityAccessEnum.Grant);
                });
        }

        canAddEdit() {
            return (this.block && ((!this.block.id && this.canAddPermission) || (this.block.id && this.canEditPermission)));
        }

        selectedBlockTypeChanged() {
            if (this.block.displayReasonOnBook) {
                return;
            }
            //dont trigger if unchanged?
            this.block.reason = this.block.blockType.displayName;
            this.rootScope.$apply();
        }

        displayReasonOnBookChanged() {
            if (this.block.displayReasonOnBook) {
                this.block.reason = (this.block.reason == this.block.blockType.displayName) ? "" : this.block.reason;
            }
            else {
                this.block.reason = this.block.blockType.displayName;
            }
        }

        private createNewBlock(date, startTime, appointmentBookIncrement) {
            this.block = <Block>{
                startDate: date,
                startTimeSegmented: {
                    value: new Date(Date.now())
                },
                endTimeSegmented: {
                    value: new Date(Date.now())
                }
            };

            if (startTime != undefined) {
                this.block.startTimeSegmented.value.setHours(startTime.format("HH"));
                this.block.startTimeSegmented.value.setMinutes(startTime.format("mm"));

                var endTime = moment(startTime).add(appointmentBookIncrement, 'minutes');
                this.block.endTimeSegmented.value.setHours(endTime.format("HH"));
                this.block.endTimeSegmented.value.setMinutes(endTime.format("mm"));
            }
        }

        getResources() {
            if (!this.resources) {
                this.updateResources();
            }
        }

        updateResources() {
            // TODO: Replace will call to availability api
            let service = this;
            if (!this.updateDateTimes()) {
                return;
            }
            this.restServer.getBlockResources(this.block, function (response) {
                if (response.length > 0) {
                    // add empty
                    response.unshift({
                        id: 0,
                        displayName: ""
                    });
                }
                service.resources = response;
            }
            );
        }

        private updateDateTimes() {
            var formattedStartDate = moment(this.block.startDate).format("M-D-YYYY");

            var startDateTime = moment(`${formattedStartDate} ${this.block.startTimeSegmented.value.getHours()}:${this.block.startTimeSegmented.value.getMinutes()}`, "M-D-YYYY h:m a");
            var endDateTime = moment(startDateTime).add(this.duration, "minutes");

            if (endDateTime.diff(startDateTime) <= 0) {
                this.rootScope.$broadcast("showMessage", { message: "End time must be greater than start time" });
                return false;
            }

            this.block.startDateTime = startDateTime.toDate();
            this.block.endDateTime = endDateTime.toDate();

            return true;
        }

        saveBlock() {
            if (!isObject(this.block.blockType)) {
                this.rootScope.$broadcast("showMessage", { message: "Select a block type" });
                return;
            }

            if (!this.updateDateTimes()) {
                return;
            }

            var affectedColumns = [];

            this.block.blockTypeId = this.block.blockType.id;

            if (this.block.employee) {
                this.block.employeeId = this.block.employee.id;
            }
            else {
                this.block.employeeId = null;
            }

            if (this.block.resource) {
                this.block.resourceId = this.block.resource.id;
            }
            else {
                this.block.resourceId = null;
            }

            if (this.globals.isEmployeeView) {
                if (this.block.id != undefined && (this.block.employeeId != this.block.originalEmployeeGlobalId ||
                    this.block.originalStartDate != this.block.startDate)) {
                    affectedColumns.push({ date: moment(this.block.originalStartDate), entityId: this.block.originalEmployeeGlobalId });
                }
                affectedColumns.push({ date: moment(this.block.startDate), entityId: this.block.employeeId });
            } else {
                if (this.block.id != undefined && (this.block.resourceId != this.block.originalResourceId ||
                    this.block.originalStartDate != this.block.startDate)) {
                    affectedColumns.push({ date: moment(this.block.originalStartDate), entityId: this.block.originalResourceId });
                }
                affectedColumns.push({ date: moment(this.block.startDate), entityId: this.block.resourceId });
            }

            this.modal.showProcessingOverlay();

            var onSuccess = (response) => {
                this.block.entityVersion = response.entityVersion;
                this.modal.hideProcessingOverlay();
                var redraw = false;
                if (moment.duration(moment(response.startDateTime).format("H:mm:ss")) < moment.duration(this.globals.bookStartTime)) {
                    redraw = true;
                }
                this.rootScope.$broadcast("blockSaved", { affectedColumns: affectedColumns, redrawApptBook: redraw });
            };

            var onWarn = (warnings) => {
                var warningCallback = (result) => {
                    if (result == Meevo.Model.MessageBoxButtonResult.Yes) {
                        this.block.suppressWarnings = true;
                        this.restServer.saveAppointBlock(this.block, onSuccess);
                    }
                }

                this.modal.showMessages(warnings, "HEADER_BLOCK_WARNING", { buttonsType: Meevo.Model.ButtonTypeEnum.YesNo, callback: warningCallback });
            }

            this.block.suppressWarnings = false;
            this.restServer.saveAppointBlock(this.block, onSuccess, onWarn);
        }

        cancel() {
            if (this.blockId != undefined) {
                this.restServer.deleteLock(this.blockId, "AppointBlock");
            }
            this.rootScope.$broadcast("cancelBlockSave");
        }

        blockTypeChanged() {
            if (this.block.blockType) {
                this.dataService.getItem("blockType", new Guid(this.block.blockType.id))
                    .then((blockType: any) => {
                        if (blockType.defaultMinutes) {
                            this.duration = blockType.defaultMinutes;
                        }
                    });
                if (!this.block.displayReasonOnBook) {
                    this.block.reason = this.block.blockType.displayName;
                }
            }
        }

        increments;
        loadDurationIncrements() {
            if (!this.increments) {
                this.increments = [];
                this.durationIncrements.getIncrements(480, false)
                    .then((increments) => {
                        this.increments = increments;
                    });
            }
        }

        startTimeChanged() {
            this.resources = undefined;
        }

        durationChanged() {
            this.resources = undefined;
        }

        startDateChanged() {
            this.resources = undefined;
        }

        showChangeLog() {
            this.modal.showBlockAuditLog(this.block.id);
        }

        static factory(): Function {
            let svc = (restServer, rootScope, modal, globals, securityChecker, dataService, durationIncrements) => {
                return new BlockEditorService(restServer, rootScope, modal, globals, securityChecker, dataService, durationIncrements);
            }

            svc.$inject = ['restServer', '$rootScope', 'appointmentBookModalService', 'appointmentBookGlobalsService', "meevo.components.common.SecurityService",
                "meevo.components.common.DataService", "meevo.components.common.durationIncrementsService"];
            return svc;
        }
    }

    angular.module("ApptBookApp")
        .service("BlockEditorService", BlockEditorService.factory());
}